import { useSelector, useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { NotificationManager } from 'react-notifications';
import { useAccessToken } from '../../../components/common/hooks/useAccessToken';
import { isAdminSelector } from '../../../components/store/auth/selectors';
import { showLoader, hideLoader } from '../../../components/store/common/slice';
import { StyledButtonWrapper } from './RenewReports.styled';

const RenewReports = () => {
    const isAdmin = useSelector(isAdminSelector);
    const { t } = useTranslation();
    const client = useAccessToken();
    const dispatch = useDispatch();

    const onGenerateClick = async () => {
        dispatch(showLoader());
        const result = await client.post('/operations/plans-to-renew/');
        dispatch(hideLoader());
        if (result.sent) NotificationManager.success(t('adminReports.success'))
        else NotificationManager.error(t('buildings.something_wrong'))
    };

    if (!isAdmin) return <div>{t('searchPayments.noAdminRights')}</div>;
    
    return (
        <StyledButtonWrapper>
            <button 
                className='bllink-button' 
                onClick={onGenerateClick} 
            >
                {t('adminReports.generateBtn')}
            </button>
        </StyledButtonWrapper>
    );
};

export default RenewReports;